import { get, post } from '../http-calls';

export const getMAMappingCategory_SearchAccounts = async (accountCode) => {
    let res = await get(`MappingCategory/MAMappingCategory_SearchAccounts?AccountCode=${accountCode || ''}`, { useAuthToken: true });
    return res;
};
export const getMAMappingCategory_Accounts = async (maMappingCategoryID) => {
    let res = await get(`MappingCategory/MAMappingCategory_Accounts?MAMappingCategoryID=${maMappingCategoryID || ''}`, { useAuthToken: true });
    return res;
};

export const postMAMappingCategory_AddNominalAccount = async (data) => {
    let res = await post(`MappingCategory/MAMappingCategory_AddNominalAccount`, data, { useAuthToken: true });
    return res;
};

export const postMAMappingCategory_SwitchReverseSign = async (MAMappingCategoryID, setReverse) => {
    let res = await post(
        `MappingCategory/MAMappingCategory_SwitchReverseSign?MAMappingCategoryID=${MAMappingCategoryID}&setReverse=${setReverse}`,
        {},
        { useAuthToken: true }
    );
    return res;
};
export const postMAMappingCategory_DeleteNominalAccount = async (maMappingCategoryAccountID) => {
    let res = await post(`MappingCategory/MAMappingCategory_DeleteNominalAccount?MAMappingCategoryAccountID=${maMappingCategoryAccountID || ''}`, null, {
        useAuthToken: true
    });
    return res;
};
